<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Meta por Cliente"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anosafra"
              label="Ano Safra"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              placeholder="Selecione o Vendedor"
              v-model="filter.salesman"
              :options="filteredSalesmen"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :loading="loadingSalesmen"
              label="name"
              track-by="id"
              :disabled="!currentUser.is_admin && !currentUser.is_manager"
              @input="findClients('')"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Cliente</label>
            <multiselect
              placeholder="Selecione o Cliente"
              v-model="filter.client"
              :options="filter.clients"
              label="razao_social"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              @search-change="findClients"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Coluna</label>
            <multiselect
              placeholder="Tipo de Coluna"
              :options="tableColumn"
              v-model="filter.tableColumn"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :multiple="true"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-2">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button >
          <base-button type="secondary" class="mt-2" @click="exportToExcel()">Gerar Excel</base-button>
           <base-button type="primary"
            @click="generateReport"
            class="ml-2 mt-2"
            :loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card v-show="Object.keys(tableData).length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Meta por Cliente - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.salesman && Object.keys(filter.salesman).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Vendedor - {{ filter.salesman.name }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="width: 200px; display: block; margin-left: auto; margin-right: auto;"
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Meta por Cliente - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anosafra && Object.keys(filter.anosafra).length"
        >
          Ano Safra: {{ filter.anosafra.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesmen && Object.keys(filter.salesmen).length"
        >
          Vendedor: {{ filter.salesman.name }}
        </h6>
        <br />
        <br />
        <br />
      </div>

      <card v-for="(data, index) in tableData" :key="`${data.client.id}-${index}`">
        <el-table
          :data="data.goals"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column label="META">
            <el-table-column :label="data.client.razao_social">
              <el-table-column
                v-if="filter.tableColumn.includes('Grupo') || filter.tableColumn.includes('Todas')"
                label="Grupo"
                min-width="125px"
                prop="group"
                sortable
              />
              <!-- indice tecnologico -->
            <el-table-column
                v-if="
                  filter.tableColumn.includes('Meta Financeira') ||
                  filter.tableColumn.includes('Todas')
                "
                :formatter="numberFormatter"
                label="Meta Financeira"
                prop="financial_values"
                min-width="125px"
                sortable
                v-slot="{ row }"
              >
                {{
                  (row.financial_values || 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "brl",
              })
                }}
              </el-table-column>
              <el-table-column
                v-if="filter.tableColumn.includes('Realizada') || filter.tableColumn.includes('Todas')"
                :formatter="numberFormatter"
                label="Realizada"
                prop="salesman_sales"
                min-width="125px"
                sortable
                v-slot="{ row }"
              >
              {{
                (row.salesman_sales || 0).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
              </el-table-column>
              <el-table-column
                v-if="filter.tableColumn.includes('Meta Atingida') || filter.tableColumn.includes('Todas')"
                :formatter="numberFormatter"
                label="Meta Atingida"
                min-width="125px"
                prop="salesman_percentage"
                v-slot="{ row }"
                sortable
              >
               {{ ((row.salesman_percentage > 120) ? 120 : parseFloat(value || 0)).toLocaleString("pt-BR", { day: "numeric" }) }}%
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />
      </card>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

import { Table, TableColumn } from "element-ui";
import Card from '../../components/Cards/Card.vue';

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    Card,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        anosafra: {},
        goalType: "Vendedor",
        salesman: {},
        client: {},
        clients: [],
        dateLimit: null,
        tableName: [],
        tableColumn: [],
        grupo_id: [],
        manager: {},
      },
      salesmen: [],
      filteredSalesmen: [],
      clients: [],
      anosafras: [],
      goalTypes: [],
      groups: [],
      tableData: [],
      lastEdition: new Date(),
      dateLimit: [],

      loadingSalesmen: false,
      isLoading: false,
      salesmen_type: "",
      currentUser: {},
      tableColumn: ['Grupo', 'Meta', 'Realizada', 'Meta Atingida', 'Todas']
    };
  },
  methods: {
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    clearFilters() {
      this.filter.salesman = {},
      this.filter.client = {},
      this.filter.tableColumn = []
    },
    async generateReport() {
      this.isLoading = true;
      try {
        const response = await this.$http.secured.get("/api/v1/report/goals_by_client", {
          params: {
            salesman_id: this.filter.salesman.id,
            anosafra_id: this.filter.anosafra.id,
            client_id: this.filter.client.id
          }
        })
        this.lastEdition = new Date();
        this.tableData = response.data;
      } catch (error) {}
      this.isLoading = false;
    },
    getSummaries(param) {
      if(!Object.keys(param).length) return;

      var { columns, data } = param;
      var sums = [];

      // console.log('param', param)
      // console.log('columns', columns)

      for (const index in columns) {
        if (index == 0) {sums[index] = 'TOTAL'; continue;}

        var values = data.map(item => Number(item[columns[index].property]));

        if(values.every(value => isNaN(value))) {sums[index] = ' '; continue;}

        if(index == (columns.length - 1)){
          sums[index] = 100.0 * (parseFloat(sums[2]) / parseFloat(sums[1]))
          if(sums[index] > 120) sums[index] = 120

          sums[index] = sums[index].toFixed(2) + '%'
          continue
        }

        sums[index] = values.reduce((prev, curr) => (Number(curr) || 0 ) + prev, 0)
        // sums[index] = sums[index].toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      }

      // Aqui é que está bugando
      sums[1] = parseFloat(sums[1]).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      sums[2] = parseFloat(sums[2]).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      // sums[3] = sums[3].toFixed(2) + '%'
      return sums
    },
    initSalesmen() {
      var data = {
        name_only: true,
        q: {is_salesman: true, status: this.active }
      }

      this.loadingSalesmen = true
      if(this.currentUser.is_manager && !this.currentUser.is_admin) data.q['manager_id'] = this.currentUser.id
      if (this.filter.manager && this.filter.manager.coordinated_id) data.q["manager_id"] = this.filter.manager.coordinated_id;
      if(this.currentUser.is_admin && this.filter.manager) data.q['manager_id'] = this.filter.manager.id
      if(this.filter.anosafra && this.filter.anosafra.id) data.q['anosafra_id'] = this.filter.anosafra.id

      this.$http.secured
        .get("/api/v1/users", {params:data})
        .then((response) => {
          console.log(response)
          this.salesmen = response.data
          this.filteredSalesmen = this.salesmen
          this.loadingSalesmen = false
        })
        .catch(() => this.loadingSalesmen = false);
    },
    initClients(q = '') {
      this.$http.secured.get("/api/v1/clients", {params: {q: {razao_social: q}}}).then((response) => {
        this.clients = response.data.clients;
      });
    },
    findClients(query) {
      var data = {
        per_page: 10,
        q: {},
      };

      if (query.trim()) data.q.razao_social = query;
      if (this.filter.salesman && this.filter.salesman.id)
        data.q.user_ids = this.filter.salesman.id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.filter.clients = response.data.clients;
        })
        .catch(() => {
          // (this.$toasted.defaultError())
          }
        );
    },
    initGroups() {
      this.$http.secured
        .get("/api/v1/grupos")
        .then((response) => (this.groups = response.data));
    },
    populateLimit(value) {
      this.dateLimit = this.dateRange(value.start_date, value.end_date);
    },
    numberFormatter(_row, _column, value) {
      return parseFloat(value || 0).toLocaleString("pt-BR", { day: "numeric" });
    },
    filterSalesmen(manager) {
      this.filteredSalesmen = manager.salesmans
    },
    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          dates.push(["01", displayMonth, i].join("/"));
        }
      }
      return dates;
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    if(this.$can('index', 'user')){
      this.initSalesmen("");
      this.initClients("");
      this.findClients("");
    }

    this.filter.tableColumn.push(this.tableColumn[4]);

    this.initGroups();

    this.currentUser = this.$currentUser()

    if(this.currentUser.is_admin){
    }else if(this.currentUser.is_manager){
      this.filter.manager = this.currentUser
    }else if(this.currentUser.is_salesman){
      this.filter.salesman = this.currentUser
      this.filter.manager = this.currentUser.manager
    }
  },
  watch: {
    'filter.tableName': function(val){
    },

    'filter.anosafra': function() {
      if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
    },
    'filter.manager': function() {
      if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
    },
  },
};
</script>
<style scoped>
  .el-table__fixed,
  .el-table__fixed-right {
    background-color: white;
    text-align: center;
  }

  #tableId{
    width: 100%;
  }
</style>
